<template>
	<div class="ptrl-20-16 box-s">
		<ul class="list_every bg_f plr-16">
      <!-- 头像 -->
      <li class="flexs flex-jus h60 bb-E c1 fz-14 ">
        <div class="w90">头像</div>
        
        <div class="flexs pr">
          <div v-if="img" class="img_contain">
            <img class="imgpre" @click="prever" :src="img" alt="">
            <img class="delImg"  @click="del" src="../../assets/img/icon/info_cha.png" alt="">
          </div>
          <div v-else>
            <van-uploader
              v-model="fileList" 
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
              :deletable="showImgDelBtn"
              />
          </div>
          <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
        </div>
      </li>
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div class="w90">昵称</div>
        <div class="flexs flex1 flex-end">
          <input placeholder="请输入昵称" v-model="userinfo.nickname" placeholder-class="c2" class="text-right mr-10 flex1" type="text">
          <div class="wh_8_14"></div>
        </div>
      </li>

      <!-- 手机号 -->
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div class="w90">手机号</div>
        <div class="flexs flex1 flex-end">
          <input readonly @input="inputPhone" v-model="phone" class="text-right mr-10 flex1 c2" type="number" maxlength="11">
          <div class="wh_8_14"></div>
        </div>
      </li>

      <!-- 性别 -->
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div>性别</div>
        <div class="flexs" @click="showSex">
          <div v-if="sex != '未知'" class="mr-10">{{sex}}</div>
          <div v-else class="mr-10 c2">请选择性别</div>
          <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
        </div>
      </li>
      
      <!-- 出生日期 -->
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div class="c1 fz-14">出生日期</div>
        <div class="flexs" @click="showTime">
          <div class="mr-10" :class="{ c2: !userinfo.birthday }">{{userinfo.birthday? userinfo.birthday: '请点击选择日期'}}</div>
          <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
        </div>
      </li>

      <!-- 专业、类别 -->
      <!-- <li class="flexs flex-jus bb-E c1 fz-14 ptb-20">
        <div class="w90">类别、专业</div>
        <div class="flexs flex1 flex-end" @click="showLevel">
          <div v-if="classTxt" class=" mr-10">{{classTxt}}</div>
          <div v-else class=" mr-10 c2">请选择专业、类别</div>
          <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
        </div>
      </li> -->
      <li class="flexs flex-jus bb-E c1 fz-14 ptb-20">
        <div class="w90">类别、专业</div>
        <div class="flexs flex1 flex-end">
          <div v-if="classTxt" class=" mr-10">{{classTxt}}</div>
          <div v-else class=" mr-10 c2">请选择专业、类别</div>
          <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
        </div>
      </li>
      <!-- 邀请码 -->
      <li class="flexs flex-jus h60 bb-E c1 fz-14">
        <div class="w90">邀请链接</div>
        <div class="flexs flex1 flex-end">
          <div>{{spread_url}}</div>
          <div class="wh_8_14"></div>
        </div>
      </li>
    </ul>

    <div class="btn_contain">
      <div class="blue_btn" @click="submit">
        提交
      </div>
    </div>
    
    <!-- 选择日期 -->
    <van-action-sheet v-model="show">
      <van-datetime-picker
      v-model="currentDate"
      type="date"
      title="选择年月日"
      @confirm="confirm"
      @cancel="show = false"
    />
    </van-action-sheet>
    
    <!-- 选择男女 -->
    <van-popup v-model="showSexFlag" round position="bottom">
      <van-picker
        title = '选择性别'
        :columns="columns"
        @cancel="showSexFlag = false"
        @confirm="onConfirmSex"
        :show-toolbar="true"
        :default-index="sexIndex"
      />
    </van-popup>
    
    <!-- 级别专业弹框 -->
    <van-popup v-model="showLevelFlag" round position="bottom">
      <van-picker
        ref="picker"
        title = '选择级别、专业'
        :columns="levelColumns"
        @cancel="showLevelFlag = false"
        @confirm="onConfirmLevel"
        :show-toolbar="true"
        :columns-field-names="columnsField"
      />
    </van-popup>
    <load :loadFlag="loadFlag"></load>
	</div>
</template>
<script>
	import load from "@/components/loading"
  import { userInfo, MajorList, userInfoUpdated, uploadFile } from '@/api/api.js'
  import { formatTime } from '@/utils/common.js'
  import { ImagePreview } from 'vant';
	export default {
		components: {
      load
		},
		data() {
			return {
        currentDate: new Date(),//默认时间
        show: false,//日期弹框是否显示
        showSexFlag: false,//性别弹框是否显示
        sexIndex: 0,//性别弹框默认值
        showLevelFlag: false, //级别专业弹框是否显示
        userinfo: {
          avatar: '',
          nickname: '',
          sex: '1',
          birthday: '',
          pc_id: ''
        },
        phone: '',
        columns: ['男', '女'],//性别弹框数据
        levelColumns: [], //级别专业数据
        columnsField:{
          text: 'text', 
          values: 'id', 
          children: 'children' 
        },
        fileList: [],
        showImgDelBtn: false,//是否展示图片上传删除按钮
        sex: '男', //页面显示性别
        classTxt: '',//专业类别显示
        defaultIndex: '',
        loadFlag: false,
        img: '',
        spread_url:'',//我的邀请链接
			};
		},
		created() {
      this.initData()
		},
    mounted(){
      
    },
    methods: {
      async initData(){
        this.loadFlag = true
        const res = await userInfo()
        this.loadFlag = false
				if(res.code == 1000){
          const { avatar, phone, nickname, sex, birthday, pc_id, sex_name, parent_pc_name, pc_name, spread_url  } = res.data
					this.userinfo = { avatar, nickname, sex, birthday, pc_id  }
          this.sex = sex_name
          this.phone = phone
          this.spread_url = spread_url //邀请链接
          if(parent_pc_name){
            this.classTxt = parent_pc_name + '-' + pc_name
          }
          this.img = avatar
          this.showImgDelBtn = true
				}else {
					 this.$toast(res.msg)
				}

        const r = await MajorList()
        if(r.code == 1000){
          const data = []
          r.data.forEach((item, index) => {
            data.push({ id: item.id, text: item.name, children: [] })
            if(item.label){
              item.label.forEach(innerItem => {
                innerItem.child.forEach(i=>{
                  data[index].children.push({ id: i.id, text: i.name })
                })
                
              })
            } else {
              item.child.forEach(innerItem => {
                data[index].children.push({ id: innerItem.id, text: innerItem.name })
                
              })
            } 
          })
          
          this.levelColumns = data
        }else {
					 this.$toast(res.msg)
				}
			},

      // 点击选择日期弹框确认
      confirm(e){
        this.userinfo.birthday = formatTime(e, 1)
        this.show = false
      },
      // 点击调起选择日期弹框
      showTime(){
        if(this.userinfo.birthday){
          this.currentDate = new Date(this.userinfo.birthday)
        }
        
        this.show = true
      },
      
      // 确认性别弹框
      onConfirmSex(e){
        this.sex = e
        this.userinfo.sex = e == '男'? 1 : 2
        this.showSexFlag = false
      },
      // 调起性别弹框
      showSex(){
        const index = this.columns.findIndex(item => item == this.sex)
        this.sexIndex = index == -1? 0:index
        this.showSexFlag = true
      },

      // 级别专业弹框确认
      onConfirmLevel(e, b){
        console.log(e, b)
        this.classTxt = e[0] + '-' + e[1]
        this.userinfo.pc_id = this.levelColumns[b[0]].children[b[1]].id
        this.showLevelFlag = false
        
      },
      
      // 调起级别专业弹框
      showLevel(a){
        this.showLevelFlag = true
      },
      
      // 手机号输入
      inputPhone(e){
        if(this.userinfo.phone.length>11) this.userinfo.phone=this.userinfo.phone.slice(0,11)
      },
      
      // 图片上传前
      beforeRead(file) {
        this.fileList = []
        let reg = "image/gif|image/jpeg|image/png";
        let formatObj = new RegExp(reg);
        const isJPG = formatObj.test(
          file.type ? file.type : file.name ? file.name : ""
        );
        const isLt2M = file.size / 1024 / 1024 < 10

        if (!isJPG) {
          this.$toast('上传头像图片格式不正确!')
        }
        if (!isLt2M) {
          this.$toast('上传头像图片大小不能超过 10MB!')
        }
        return isLt2M && isJPG;

      },

      // 图片上传后
      async afterRead(file) {
        const formData = new FormData()
        formData.append('file', file.file)
        const res = await uploadFile(formData)
        if(res.code == 1000){
          this.userinfo.avatar = res.data.path
          this.showImgDelBtn = true
        }else {
					 this.$toast(res.msg)
				}

      },

      del(){
        this.img = ''
        this.userinfo.avatar = ''
      },

      prever(){
        ImagePreview([ this.img ])
      },

      

      // 验证
      validate(){
        if(!this.userinfo.avatar || !this.userinfo.avatar.trim()){
          this.$toast('请上传头像')
          return false
        } else if (!this.userinfo.nickname || !this.userinfo.nickname.trim()) {
          this.$toast('请输入昵称')
          return false
        } else if (!(this.userinfo.sex == 1 || this.userinfo.sex == 2)) {
          this.$toast('请选择性别')
          return false
        } else if (!this.userinfo.birthday && !this.userinfo.birthday.trim()) {
          this.$toast('请选择出生日期')
          return false
        } else if (!this.userinfo.pc_id) {
          this.$toast('请选择专业、类别')
          return false
        } else {
          return true
        }
      },

      // 提交按钮
      async submit(){
        if(!this.validate()){
          return
        }
        this.loadFlag = true
        const res = await userInfoUpdated(this.userinfo)
        this.loadFlag = false
        if(res.code == 1000){
          this.$toast.success('提交成功')
          localStorage.setItem('merFlag', 1)
          setTimeout(()=>{ 
            this.$router.replace('/member')
          },500)
        }else {
					 this.$toast(res.msg)
				}
      }
    }
	}
</script>
<style lang="less" scoped>
	/deep/.van-uploader__upload {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/.van-uploader__upload-icon {
    font-size: 15px;
  }

  /deep/.van-uploader__upload {
    margin: 0;
    margin-right: 10px;
  }

  /deep/.van-uploader__preview-image {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/.van-uploader__file {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }

  /deep/ .van-uploader__preview {
    margin: 0;
    margin-right: 10px;
  }

  .imgpre {
    border-radius: 50%;
    width: 34px;
    height: 34px;
  }
  .img_contain {
    border-radius: 50%;
    width: 34px;
    height: 34px;
    margin-right: 10px;
  }

  .delImg {
    position: absolute;
    width: 16px;
    height: 16px;
    top: -7px;
    right: 9px;
  }

  /deep/.van-uploader__file-icon {
    display: none;
  }
</style>
